import { assertNotUndefined } from "@/util/typeguards.ts";
import { useSelector } from "react-redux";
import { getSelectedWorkspace } from "@/features/Workspace/Workspace.slice";
import { useGetWorkspacesQuery } from "@/services/apis/api.ts";
import { Workspace } from "@/types/generated/management-api-types";

export function useSelectedWorkspace(): Workspace {
    const selectedWorkspace = useSelector(getSelectedWorkspace);
    assertNotUndefined(selectedWorkspace);

    return selectedWorkspace;
}

// @TODO let's see if it makes send to migrate everything to this method
export function useSelectedWorkspaceFull(): Workspace {
    const { data: workspaces } = useGetWorkspacesQuery(undefined);
    const selectedWorkspaceFromState = useSelectedWorkspace();
    return (
        workspaces?.find((ws) => ws.id === selectedWorkspaceFromState.id) ||
        selectedWorkspaceFromState
    );
}

export function useOptionalSelectedWorkspace(): Workspace | undefined {
    return useSelector(getSelectedWorkspace);
}
